import { getCookie, sanitizeCookieValue } from '../browser'

export function getUserAuthValues() {
    // Drop literal "null"/"undefined" fields so a null userid cookie yields '' instead of "null".
    const [email, profileName, gender, photo, userId] = decodeURIComponent(getCookie('userid') || '')
        .split('|')
        .map(sanitizeCookieValue)
    return {
        email,
        profileName,
        gender,
        photo,
        userId
    }
}

/**
 * Masks an email address for privacy
 * Example: "john.doe@example.com" -> "jo*****@example.com"
 * @param email - The email address to mask
 * @returns The masked email address
 */
export function maskEmail(email: string): string {
    // Validate email format - must contain exactly one @ symbol
    if (!email || email.split('@').length !== 2) return email

    const [localPart, domain] = email.split('@')
    if (!localPart || !domain) return email

    const visibleChars = Math.min(2, localPart.length)
    // Make masking proportional to actual hidden character count
    const hiddenChars = localPart.length - visibleChars
    const maskedLength = Math.max(1, hiddenChars) // At least 1 asterisk for privacy
    const masked = localPart.substring(0, visibleChars) + '*'.repeat(maskedLength)
    return `${masked}@${domain}`
}
